import { Radians } from "@/libs/units/angle";
import type { Point } from "./d";
import type { ConvertableUnit } from "@/libs/units";
import { convertSmallLengthUnits } from "@/libs/units/length";

// static/cross-sectional deets 5.xlsx
export const generateEquipmentDataPoints = (
  radiusIn: number,
  xCenter: number,
  yCenter: number,
  degStart = 0,
  degEnd = 360
): Point[] => {
  const retVal = [];
  for (let i = degStart; i <= degEnd; i++) {
    const x = radiusIn * Math.cos(Radians.toThisUnit(i)) + xCenter;
    const y = radiusIn * Math.sin(Radians.toThisUnit(i)) + yCenter;
    retVal.push({ x, y });
  }
  return retVal;
};

// static/cross-sectional deets 5.xlsx
export const generateMLEDataPoints = (
  upperRadiusIn: number,
  upperXCenter: number,
  upperYCenter: number,
  lowerRadiusIn: number,
  lowerXCenter: number,
  lowerYCenter: number,
  degStart = 0,
  degEnd = 360
): Point[] => {
  const retVal = [];
  for (let i = degStart; i <= degEnd; i++) {
    if (i < 181) {
      const x = upperRadiusIn * Math.cos(Radians.toThisUnit(i)) + upperXCenter;
      const y = upperRadiusIn * Math.sin(Radians.toThisUnit(i)) + upperYCenter;
      retVal.push({ x, y });
    } else {
      const x = lowerRadiusIn * Math.cos(Radians.toThisUnit(i)) + lowerXCenter;
      const y = lowerRadiusIn * Math.sin(Radians.toThisUnit(i)) + lowerYCenter;
      retVal.push({ x, y });
    }
  }
  // This is to trick DDV into connecting the upper and lower
  // half circles together on the chart
  const lastPoint = retVal[degEnd];
  const firstPoint = retVal[degStart];
  retVal.push({ x: lastPoint.x, y: firstPoint.y });
  return retVal;
};

// No more rubs unless Ben gets exact measurements
// export const generateMotorRubDataPoints = (
//   radiusIn: number,
//   xCenter: number,
//   yCenter: number,
//   motorAngleOffCenter: number,
//   degStart = 0,
//   degEnd = 180
// ): Point[] => {
//   const retVal = [];
//   // =$K$3*COS((K9*PI())/(180+90+$Inputs.$J$44))+$K$4
//   for (let i = degStart; i <= degEnd; i++) {
//     const x =
//       radiusIn * Math.cos((i * Math.PI) / (180 + 90 + motorAngleOffCenter)) +
//       xCenter;
//     const y =
//       radiusIn * Math.sin((i * Math.PI) / (180 + 90 + motorAngleOffCenter)) +
//       yCenter;
//     retVal.push({ x, y });
//   }
//   return retVal;
// };

export interface CrossSectionTitle {
  title: string;
  value: string;
}

export function generateCrossSectionDataSetTitle(
  title: string,
  diameterIn: number,
  targetUnit: ConvertableUnit
): CrossSectionTitle {
  return {
    title,
    value: `${convertSmallLengthUnits(diameterIn, targetUnit)}${targetUnit.shortLabel}`
  };
}
